<!-- Estándar de layout: el primer elemento bajo el header queda a 26 px (10 px de .main_content + tw-pt-page) -->
<article class="tw-pt-page">
  <h1 class="tw-text-xl tw-font-medium tw-text-title-color" [class.tw-text-center]="isMobile">{{title}}</h1>
  <section [ngClass]="{ 'tw-pt-[30px]': title }">
    <ng-content></ng-content>
  </section>
</article>
